<template>
  <resource-box name="化肥价格走势">
    <div slot="back">
      <el-select
        v-model="selectedType"
        placeholder="请选择化肥类型"
        size="small"
        class="zszy_cascader"
        style="width: 180px"
        @change="handleChange"
      >
        <el-option
          v-for="item in fertilizerTypes"
          :key="item.id"
          :label="item.dimName"
          :value="item.id"
        />
      </el-select>
    </div>
    <div class="price-Trend" slot="content">
      <div ref="priceTrendRef" class="chart-container"></div>
    </div>
  </resource-box>
</template>

<script>
import ResourceBox from '@/views/ChinaMapData/components/common/resourceBox.vue';
import * as echarts from 'echarts';
import { getSubCategoryTrend } from '@/API/price/price';
import { getPriceList, getPriceTrend } from '@/API/chinaMapApi/chinaMapApi';
export default {
  components: {
    ResourceBox,
  },
  name: 'priceTrend',
  data() {
    return {
      selectedType: '',
      fertilizerTypes: [],
      chartInstance: null,
      chartData: {
        categories: [],
        factoryPrice: [],
        retailPrice: [],
      },
    };
  },
  mounted() {
    this.getDimValue();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    initChart() {
      const chartDom = this.$refs.priceTrendRef;
      this.chartInstance = echarts.init(chartDom);

      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          borderColor: '#2FF1FF',
          textStyle: {
            color: '#fff',
          },
          formatter: (params) => {
            let result = `${params[0].name}<br/>`;
            params.forEach((param) => {
              const color = param.color;
              const name = param.seriesName;
              const value = param.value;
              result += `${color} ${name}: ${value} 元<br/>`;
            });
            return result;
          },
        },
        legend: {
          data: ['出厂价', '零售价'],
          textStyle: {
            color: '#fff',
          },
          right: 20,
          top: 10,
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0%',
          top: '15%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.chartData.categories,
          axisLine: {
            lineStyle: {
              color: '#2FF1FF',
            },
          },
          axisLabel: {
            color: '#fff',
            rotate: 60,
            formatter: (value) => {
              return value.replace('-', '/');
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '价格 (元)',
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            lineStyle: {
              color: '#2FF1FF',
            },
          },
          axisLabel: {
            color: '#fff',
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(47, 241, 255, 0.2)',
            },
          },
        },
        series: [
          {
            name: '出厂价',
            type: 'line',
            data: this.chartData.factoryPrice,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#00EEFF',
            },
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#00EEFF' },
                { offset: 1, color: '#17996E' },
              ]),
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(0, 238, 255, 0.3)' },
                { offset: 1, color: 'rgba(0, 238, 255, 0.01)' },
              ]),
            },
          },
          {
            name: '零售价',
            type: 'line',
            data: this.chartData.retailPrice,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#FFD700',
            },
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#FFD700' },
                { offset: 1, color: '#FF8C00' },
              ]),
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 215, 0, 0.3)' },
                { offset: 1, color: 'rgba(255, 215, 0, 0.01)' },
              ]),
            },
          },
        ],
      };

      this.chartInstance.setOption(option);
    },
    getDimValue() {
      let params = {
        dimType: 1,
        dimCode: 'fertilizer',
      };
      getPriceList(params).then((res) => {
        if (res.code === 200) {
          if (res.data.length > 10) {
            this.fertilizerTypes = res.data.slice(0, 10);
          } else {
            this.fertilizerTypes = res.data;
          }
          this.selectedType = res.data[0]?.id || '';
          this.getPriceTrends();
        } else {
          this.fertilizerTypes = [];
        }
      });
    },
    getPriceTrends() {
      let params = {
        categoryDimId: this.selectedType,
      };
      getPriceTrend(params).then((res) => {
        this.chartData = {
          categories: [],
          factoryPrice: [],
          retailPrice: [],
        };
        if (res.code === 200) {
          if (res.data.length) {
            res.data.forEach((item) => {
              this.chartData.categories.push(item.timeDim);
              this.chartData.factoryPrice.push(item.factoryPrice);
              this.chartData.retailPrice.push(item.retailPrice);
            });
          }
          this.initChart();
        }
      });
    },
    handleChange() {
      this.getPriceTrends();
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.price-Trend {
  width: 100%;
  height: calc(100% - 40px);
  padding: 10px;
  box-sizing: border-box;

  .chart-container {
    width: 100%;
    height: 100%;
  }
}
.zszy_cascader {
  height: 34px;
  background: linear-gradient(
    180deg,
    rgba(0, 255, 153, 0) 0%,
    rgba(23, 153, 110, 1) 100%
  );
  margin-bottom: 4px;
  /deep/.el-input__inner {
    height: 34px;
    color: #ffffff;
    background: linear-gradient(
      180deg,
      rgba(0, 255, 153, 0) 0%,
      rgba(23, 153, 110, 1) 100%
    );
    border: 1px solid;
    box-shadow:
      /* 内发光增强边框层次感 */
      inset 0 0 2px rgba(100, 255, 255, 0.6),
      /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
    border-image: linear-gradient(
      135deg,
      rgba(71, 212, 157, 1) 0%,
      rgba(1, 138, 90, 0) 47.25%,
      rgba(71, 212, 157, 1) 100%
    );
  }
  /deep/.el-select-dropdown {
    background: linear-gradient(
      180deg,
      rgba(0, 255, 153, 0) 0%,
      rgba(23, 153, 110, 1) 100%
    );
    border: 1px solid;
    box-shadow:
      /* 内发光增强边框层次感 */
      inset 0 0 2px rgba(100, 255, 255, 0.6),
      /* 外阴影弱化边框硬边 */ 0 1px 1px rgba(0, 100, 100, 0.3);
    border-image: linear-gradient(
      135deg,
      rgba(71, 212, 157, 1) 0%,
      rgba(1, 138, 90, 0) 47.25%,
      rgba(71, 212, 157, 1) 100%
    );
  }
}
</style>
